// These are common styles for AuthenticationLayout
import styles from './Authentication.module.css';

const commonStyles = {
    container: `w-full h-full flex flex-col items-center justify-center gap-10`,
    wrapper: `w-full relative flex flex-col gap-10 items-center bg-[#ffffff1c] rounded-[10px] py-[45px] px-[20px] ${styles.wrapper}
              md:bg-[transparent] md:rounded-none md:p-0
    `,
    heading_wrpr: `flex flex-col items-center gap-2
                    sm:gap-3
    `,
    heading: `font-Suisse text-center text-[24px] leading-[28px] font-bold tracking-wide uppercase
              sm:text-[42px] sm:leading-[50px]
    `,
    sub_heading: `text-[17px] font-[300] text-center ${styles.sub_heading}
                  sm:text-[23px]
    `,
    sub_container: `flex flex-col items-center w-full gap-y-8
                    screen-970:w-[400px] 
    `,
    form_wrpr: `w-full flex flex-col gap-[50px]
                sm:gap-[65px]
    `,
    input_fields_wrpr: `flex flex-col gap-4 w-full relative`,
    //FOR DEMO CHANGE JUSTIFY_END to JUSTIFY_BETWEEN
    forgot_password: `w-full flex justify-end absolute -bottom-[30px] 
                      sm:-bottom-[45px] text-secondaryRed
    `,
    loginButton: `!px-[20px] !pt-[10px] !pb-[6px] font-Suisse w-full flex items-center justify-center leading-[19px]
                    md:!px-[35px] md:!pt-[15px] md:!pb-[10px]
    `,
    bottom_cntnt: `flex flex-col w-full gap-[15px] items-center
                   sm:gap-[25px]
    `,
    orContainer: `flex items-center justify-center gap-x-6 w-[65%]`,
    google_btn: `!px-[20px] !py-[10px] font-[400] w-full flex items-center justify-center leading-[19px] gap-2
                  md:!px-[35px] md:!py-[15px] 
    `,
    orLines: `w-full h-px bg-white`,
    pageLinks: `text-secondaryRed cursor-pointer text-[13px]
                sm:text-[16px] 
                hover:underline
    `,
}

export { commonStyles };
